import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gxpn792gv: FaireProductEntity = {
  token: "p_3gxpn792gv",
  type: "product",
  name: "DILF Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/18791d15fa3cf8556c6da726c1cf0a893f885bc68d60bb1bb42875e2770e1487.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9360753f4ba4f02ca8341481737a711717227be5ef353a09780d4cbd56c41067.jpeg",
    "https://cdn.faire.com/fastly/6faa9d21594b18aa0faa4b060612b9cefc53f5b258973c8d8128fc85bace931e.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/df2b7c39e0981ab4a42ffa96569de58a42444c2562f8c0e78b9252869fe99811.jpeg",
    "https://cdn.faire.com/fastly/16d3d6ec3cb064552a67cc81bd44a2498256b8ed5ad33512981e6610a6e0d771.jpeg"
  ],
  priceDollars: 6.75,
  description: "Because DILFs need socks too. Don these socks like a good Daddy should. 🥵 \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:28.917Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
